const domainId = "?domainId=8";
const projectId = "&projectId=7";
const apiConfig = {
  /*首页*/
  indexApi: {
    bannerList: "",
  },
  /*上传*/
  uploadApi: {
    fileup: "_fileup",
    downfile:
      "/_utils/download/downloadResource.rst" +
      domainId +
      "&objType=CommonDownload&storedMode=d",
  },

  userApi: {
    sendacode: "_bases/sso/register/api/sendacode.rst" + domainId,
    validateimage: "_control/validateimage",
    login: "_bases/sso/api/login.rst" + domainId + projectId,
    userreg: "_bases/sso/register/api/add.rst" + domainId + projectId,

    batchs: "_apps/generalorder/order/api/v1/batchs.rst" + domainId + projectId,
    cancel: "_apps/generalorder/order/api/v1/cancel.rst" + domainId + projectId,
    deleteyy:
      "_apps/generalorder/order/api/v1/delete.rst" + domainId + projectId,
    updateyy:
      "_apps/generalorder/order/api/v1/update.rst" + domainId + projectId,
    editpass: "_bases/sso/register/api/update.rst" + domainId + projectId,
    forgetpass: "_customs/iec/sso/api/findpwd.rst" + domainId + projectId, //_customs/iec/sso/api/findpwdBySms.rst
    userinfo: "_apps/generalorder/sso/api/v1/info.rst" + domainId + projectId,
    loginout: "_bases/sso/api/logout.rst",
    myorders:
      "_apps/generalorder/order/api/v1/myorders.rst" + domainId + projectId,
    resources:
      "_apps/generalorder/resouce/api/view/v1/resources.rst" +
      domainId +
      projectId,
    progress: "_apps/generalorder/order/api/v1/progress.rst" + domainId,
    uppingz: "_customs/iec/manage/record/api/v1/update.rst" + domainId,
  },
};

export default apiConfig;



// WEBPACK FOOTER //
// ./src/request/baseConfig/apiConfig.js